module.exports = __webpack_public_path__ + "static/media/classification_of_anomalies.0d5e4552.jpg";